import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { ShowMoreButton, ShowMoreButtonContainer } from "../../homePage.styles";
import { MoreAccessedServicesContainer } from "./moreAccessedServices.styles";
import { Section, SectionTitle } from "components/section";
import {
  MoreAccessedService,
  MoreAccessedServiceDescription,
  MoreAccessedServiceTitle,
} from "components/servicesContainer";
import { useHomeState, ACTION_TYPES, useHomeDispatch } from "pages/home/context/home-context";
import { useHomeController } from "pages/home/context/home-controller";
import { useAppState } from "main/context/app-context";


export function MoreAccessedServicesSection() {
  const navigate = useNavigate();

  const { linkServices } = useHomeState();
  const { listLinkServices, convertIcon } = useHomeController();
  const { homeData } = useAppState();
  const homeDispatch = useHomeDispatch();

  useEffect(() => {
    (async () => {
      // Se os dados já foram carregados no AppState, usa eles
      if (homeData?.linkServices && !linkServices) {
        homeDispatch({
          type: ACTION_TYPES.setLinkServices,
          payload: homeData.linkServices,
        });
      } else if (!linkServices && !homeData?.linkServices) {
        // Só carrega se não existir nem no AppState nem no HomeState
        await listLinkServices(12);
      }
    })();

  }, [homeData?.linkServices, linkServices]);



  return (
    <Section background="white">
      <SectionTitle>Serviços mais acessados</SectionTitle>
      <MoreAccessedServicesContainer>
        {linkServices?.map((service) => (
          <MoreAccessedService
            key={service.id}
            role="button"
            tabIndex={0}
            aria-label={`Abrir serviço ${service.title}`}
            onClick={() => window.open(service.url, "_blank")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                window.open(service.url, "_blank");
              }
            }}
          >
            <img
              src={convertIcon(service.icon)}
              alt={service.title}
            />

            <div>
              <MoreAccessedServiceTitle>
                {service.title}
              </MoreAccessedServiceTitle>

              <MoreAccessedServiceDescription>
                {service.subtitle}
              </MoreAccessedServiceDescription>
            </div>
          </MoreAccessedService>
        ))}
      </MoreAccessedServicesContainer>
      <ShowMoreButtonContainer>
        <ShowMoreButton onClick={() => navigate("/servicos")}>
          Todos os serviços
        </ShowMoreButton>
      </ShowMoreButtonContainer>
    </Section>
  );
}
